import React, { useState } from 'react'
import { IEdiMessage } from 'types/graphqlTypes'
import { TableCell, TableRow, Button } from 'transfix-ui'
import { TransactionSetDescription } from './TransactionSetDescription'
import { EdiMessageTypeForm } from './forms/EdiMessageTypeForm'
import {
  TConnectionConfigType,
  TEdiMessageTypeSchema,
} from './forms/EdiMessageTypeForm/EdiMessageTypeSchema'
import { getHandlerDescription } from './utils'

interface IEdiRoutingTableRowProps {
  connectionConfigId: string
  connectionConfigType: TConnectionConfigType
  ediMessageType: IEdiMessage
  onPersistEdiMessageType: (formParams: TEdiMessageTypeSchema) => void
}

export const EdiRoutingTableRow = ({
  connectionConfigId,
  connectionConfigType,
  ediMessageType,
  onPersistEdiMessageType,
}: IEdiRoutingTableRowProps) => {
  const [isEditing, setIsEditing] = useState<boolean>(false)

  const submitSuccessHandler = (formParams: TEdiMessageTypeSchema) => {
    onPersistEdiMessageType(formParams)
    setIsEditing(false)
  }
  const startEditingHandler = () => setIsEditing(true)
  const cancelEditingHandler = () => setIsEditing(false)

  return (
    <TableRow>
      {isEditing ? (
        <TableCell colSpan={3}>
          <EdiMessageTypeForm
            ediMessageType={ediMessageType}
            connectionConfigType={connectionConfigType}
            connectionConfigId={connectionConfigId}
            onSubmitSuccess={submitSuccessHandler}
            onCancel={cancelEditingHandler}
          />
        </TableCell>
      ) : (
        <>
          <TableCell>
            <TransactionSetDescription ediMessageType={ediMessageType} />
          </TableCell>
          <TableCell>{getHandlerDescription(ediMessageType)}</TableCell>
          <TableCell>
            <Button onClick={startEditingHandler}>edit</Button>
          </TableCell>
        </>
      )}
    </TableRow>
  )
}
